import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { forceLogout } from '../../store/slices/authSlice';
import { getToken } from '../../services/auth/authService';

const AuthGuard = ({ children }) => {
  const { isAuthenticated } = useSelector(state => state.auth);
  const dispatch = useDispatch();

  useEffect(() => {
    const checkToken = async () => {
      if (isAuthenticated) {
        const token = await getToken();
        if (!token) {
          console.log('AuthGuard: Token no encontrado, forzando logout');
          dispatch(forceLogout());
        }
      }
    };

    // Solo verificar después de que el usuario esté completamente autenticado
    // y dar más tiempo para que se complete la sincronización
    if (isAuthenticated) {
      const initialCheck = setTimeout(checkToken, 3000); // Aumentado a 3 segundos
      return () => clearTimeout(initialCheck);
    }
  }, [isAuthenticated, dispatch]);

  return children;
};

export default AuthGuard;